import { CornerDownRight } from 'lucide-react'
import type { ClarifyingAnswerPayload, ClarifyingQuestion } from '@/types'

interface AnsweredViewProps {
  questions: ClarifyingQuestion[]
  payload: ClarifyingAnswerPayload
}

/** Read-only transcript of a submitted clarifying card. */
export function AnsweredView({ questions, payload }: AnsweredViewProps) {
  return (
    <div className="flex flex-col gap-3">
      {questions.map((q) => {
        const answer = payload.answers[q.id]
        const parts: string[] = []
        if (answer?.selected?.length) parts.push(...answer.selected)
        if (answer?.free_text) parts.push(answer.free_text)
        const skipped = answer?.skipped && parts.length === 0
        return (
          <div key={q.id} className="flex flex-col gap-1">
            <p className="text-sm font-medium text-foreground">{q.question}</p>
            {/* items-start so the arrow sits on the first line of a wrapped
                answer; min-w-0 so a signed URL can wrap at all rather than
                stretching the row past the card. */}
            <p className="flex items-start gap-1.5 text-sm text-muted-foreground">
              <CornerDownRight className="mt-0.5 size-3.5 shrink-0" />
              {skipped ? (
                <span className="italic">Skipped</span>
              ) : parts.length ? (
                <span className="min-w-0 break-words text-david-high-contrast">
                  {parts.join(', ')}
                </span>
              ) : (
                <span className="italic">No answer</span>
              )}
            </p>
          </div>
        )
      })}

      {payload.reply && (
        <p className="flex items-start gap-1.5 border-t pt-2 text-sm text-muted-foreground">
          <CornerDownRight className="mt-0.5 size-3.5 shrink-0" />
          <span className="min-w-0 break-words text-david-high-contrast">
            {payload.reply}
          </span>
        </p>
      )}
    </div>
  )
}
